var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import '../scss/base.scss';
import { allDifficulties, defaultDifficulty, getDifficultyByLevel, } from './difficulties';
var difficultyLevelSELECT = (document.getElementById('difficultyLevel'));
var numberOfRowsINPUT = (document.getElementById('numberOfRows'));
var numberOfColsINPUT = (document.getElementById('numberOfCols'));
var numberOfMinesINPUT = (document.getElementById('numberOfMines'));
var createGameFORM = document.getElementById('createGame');
var difficulty = __assign({}, defaultDifficulty); // remove shadow copy (i hate it :/)
/**
 * It updates the values of the inputs to match the values of the difficulty object
 */
var udpateInputs = function () {
    numberOfRowsINPUT.value = difficulty.numberOfRows.toString();
    numberOfColsINPUT.value = difficulty.numberOfCols.toString();
    numberOfMinesINPUT.value = difficulty.numberOfMines.toString();
};
udpateInputs();
difficultyLevelSELECT.value = difficulty.level;
/**
 * It returns the level of the difficulty that matches the current difficulty
 * @returns The level of the difficulty.
 */
var getMatchingLevel = function () {
    var level = (allDifficulties.find(
    // find the difficulty that matches the current difficulty
    function (_a) {
        var numberOfRows = _a.numberOfRows, numberOfCols = _a.numberOfCols, numberOfMines = _a.numberOfMines;
        return numberOfRows === difficulty.numberOfRows &&
            numberOfCols === difficulty.numberOfCols &&
            numberOfMines === difficulty.numberOfMines;
    }
    // if there is no match, return custom difficulty level
    ) || { level: 'custom' }).level;
    return level;
};
/**
 * It updates the difficulty object with the values from the input fields
 */
var inputChanged = function () {
    // update difficulty
    var numberOfRows = Number(numberOfRowsINPUT.value);
    var numberOfCols = Number(numberOfColsINPUT.value);
    var numberOfMines = Number(numberOfMinesINPUT.value);
    difficulty.numberOfCols = numberOfCols;
    difficulty.numberOfRows = numberOfRows;
    difficulty.numberOfMines = numberOfMines;
    // update difficulty level
    var level = getMatchingLevel();
    difficulty.level = level;
    difficultyLevelSELECT.value = level;
};
/**
 * It updates the difficulty level and the inputs
 */
var selectChanged = function () {
    difficulty.level = difficultyLevelSELECT.value;
    // update difficulty
    var dedicatedDifficulty = getDifficultyByLevel(difficulty.level);
    if (dedicatedDifficulty) {
        difficulty.numberOfCols = dedicatedDifficulty.numberOfCols;
        difficulty.numberOfRows = dedicatedDifficulty.numberOfRows;
        difficulty.numberOfMines = dedicatedDifficulty.numberOfMines;
    }
    udpateInputs();
};
difficultyLevelSELECT.addEventListener('change', selectChanged);
numberOfRowsINPUT.addEventListener('change', inputChanged);
numberOfColsINPUT.addEventListener('change', inputChanged);
numberOfMinesINPUT.addEventListener('change', inputChanged);
createGameFORM.addEventListener('submit', function (event) {
    event.preventDefault();
    var url = new URL(window.location.href);
    url.pathname = '/'; // reset pathname to '/'
    // set search params
    url.searchParams.set('difficulty', difficulty.level);
    if (difficulty.level === 'custom') {
        url.searchParams.set('numberOfRows', difficulty.numberOfRows.toString());
        url.searchParams.set('numberOfCols', difficulty.numberOfCols.toString());
        url.searchParams.set('numberOfMines', difficulty.numberOfMines.toString());
    }
    // redirect to new url
    window.location.href = url.href;
});
